var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3H5.5C4.65625 3 4 3.6875 4 4.5V13.5C4 14.3438 4.65625 15 5.5 15H18.5C19.3125 15 20 14.3438 20 13.5V4.5C20 3.6875 19.3125 3 18.5 3ZM5.5 4H18.5C18.75 4 19 4.25 19 4.5V5.8125C18.3125 6.375 17.3125 7.1875 14.2812 9.59375C13.75 10.0312 12.7188 11.0312 12 11C11.25 11.0312 10.2188 10.0312 9.6875 9.59375C6.65625 7.1875 5.65625 6.375 5 5.8125V4.5C5 4.25 5.21875 4 5.5 4ZM18.5 14H5.5C5.21875 14 5 13.7812 5 13.5V7.09375C5.6875 7.6875 6.8125 8.59375 9.0625 10.375C9.71875 10.9062 10.8438 12.0312 12 12C13.125 12.0312 14.25 10.9062 14.9062 10.375C17.1562 8.59375 18.2812 7.6875 19 7.09375V13.5C19 13.7812 18.75 14 18.5 14Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.7a1b38be.svg";
export { ForwardRef as ReactComponent };